import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetOpusAgentTurnFeedbackMutationVariables = Types.Exact<{
  input: Types.SetOpusAgentTurnFeedbackInput;
}>;


export type SetOpusAgentTurnFeedbackMutation = { __typename?: 'Mutation', setOpusAgentTurnFeedback: { __typename?: 'SetOpusAgentTurnFeedbackResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, turn?: { __typename?: 'OpusAgentChatTurn', id: string, myFeedback?: { __typename?: 'OpusAgentChatTurnFeedback', id: string, selection: Types.FeedbackSelection, text: string } | null } | null } };


export const SetOpusAgentTurnFeedbackDocument = gql`
    mutation SetOpusAgentTurnFeedback($input: SetOpusAgentTurnFeedbackInput!) {
  setOpusAgentTurnFeedback(input: $input) {
    success
    error {
      code
      message
    }
    turn {
      id
      myFeedback {
        id
        selection
        text
      }
    }
  }
}
    `;
export type SetOpusAgentTurnFeedbackMutationFn = Apollo.MutationFunction<SetOpusAgentTurnFeedbackMutation, SetOpusAgentTurnFeedbackMutationVariables>;

/**
 * __useSetOpusAgentTurnFeedbackMutation__
 *
 * To run a mutation, you first call `useSetOpusAgentTurnFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOpusAgentTurnFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOpusAgentTurnFeedbackMutation, { data, loading, error }] = useSetOpusAgentTurnFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOpusAgentTurnFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SetOpusAgentTurnFeedbackMutation, SetOpusAgentTurnFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOpusAgentTurnFeedbackMutation, SetOpusAgentTurnFeedbackMutationVariables>(SetOpusAgentTurnFeedbackDocument, options);
      }
export type SetOpusAgentTurnFeedbackMutationHookResult = ReturnType<typeof useSetOpusAgentTurnFeedbackMutation>;
export type SetOpusAgentTurnFeedbackMutationResult = Apollo.MutationResult<SetOpusAgentTurnFeedbackMutation>;
export type SetOpusAgentTurnFeedbackMutationOptions = Apollo.BaseMutationOptions<SetOpusAgentTurnFeedbackMutation, SetOpusAgentTurnFeedbackMutationVariables>;